import NotificationUrl from '@engine/features/notification_urls';

function cleanUpErrorMessage(urlsType) {
  var timeout = 3000;
  var urlContainer = '#' + urlsType + '-panel-wrapper';
  setTimeout(function () {
    $(urlContainer).find('.alert.alert-danger-light').remove();
  }, timeout);
}

function isTheActiveTargetANotificationUrl(stringToCheck) {
  return stringToCheck.includes('notification');
}

function configurableUrlRequest(href, requestType, urlsType) {
  $.ajax({
    method: requestType,
    url: href,
    data: $('form#' + urlsType + '-form').serialize(),
    dataType: 'html',
    success: function success(html) {
      $('.' + urlsType + '-list').html($.parseHTML(html));
      $('form#' + urlsType + '-form').trigger('reset');
      $('select#url-type').trigger('chosen:updated');
      cleanUpErrorMessage(urlsType);

      if (isTheActiveTargetANotificationUrl(urlsType)) {
        NotificationUrl.toggleSupportedFeatureEditability();
      }
    }
  });
}

function create(_id, href, urlsType) {
  configurableUrlRequest(href, 'POST', urlsType);
}

function update(_id, href, urlsType) {
  configurableUrlRequest(href, 'PUT', urlsType);
}

function destroy(params) {
  var data = params.data;
  $.ajax({
    method: data.request,
    url: data.href + '?' + $.param({
      owner_id: data.ownerId,
      owner_type: data.ownerType
    }),
    success: function success(res) {
      if (!res.error) {
        $('.' + params.targetId.replace('delete-', '')).remove();

        if (data.urlEnabled && isTheActiveTargetANotificationUrl(data.href)) {
          NotificationUrl.toggleSupportedFeatureEditability();
        }
      }
    }
  });
}

function listenForEdit() {
  $(document).on('click', '.configurable-urls a[id^="update-"]', function () {
    var url = $(this).data('url');
    var $modal = $('#' + $(this).data('type') + '-modal');
    $modal.find('select.url-type').val(url.url_type).trigger('chosen:updated');
    $modal.find('input.url').val(url.url);
    $modal.find('input.enabled[type="checkbox"]').prop('checked', url.enabled);
  });
}

var ConfigurableUrl = {
  create: create,
  update: update,
  destroy: destroy,
  listenForEdit: listenForEdit
};
export default ConfigurableUrl;